/* (c) Dalineage, s.r.o. 2020-2025, all rights reserved */
package com.dalineage.common.adt

import io.circe.Codec

object TreeNodeADT {

  case class TreeNode(
    `type`: Int,
    key: String,
    parentKey: Option[String],
    caption: String,
    icon: String,
    toolTip: String,
    properties: Map[Int, String],
    children: Option[Seq[TreeNode]]
  ) derives Codec.AsObject {
    def isLeaf: Boolean = children match {
      case None => false
      case Some(c) => c.isEmpty
    }
  }
}
